module.exports = __webpack_public_path__ + "img/Icons-Actions-ic-actions-user.af7a676a.svg";